<template>
  <div class="page_sublink">
    <ul v-if="this.recruit_check()">
      <li><router-link v-bind:to="{name:'company_index', params: {company: 'company'}}" :class="[select_tab('company')]" exact>会社概要</router-link></li>
      <li><router-link v-bind:to="{name:'history_index', params: {company: 'companyhistory'}}" :class="[select_tab('companyhistory')]" exact>沿革</router-link></li>
      <li><router-link v-bind:to="{name:'awards_index', params: {company: 'awards'}}" :class="[select_tab('awards')]" exact>受賞歴</router-link></li>
      <li><router-link v-bind:to="{name:'sustainability_index', params: {company: 'sustainability'}}" :class="[select_tab('sustainability')]" exact>サスティナビリティ</router-link></li>
      <li><router-link v-bind:to="{name:'comp_index', params: {company: 'comp'}}" :class="[select_tab('comp')]" exact>決算公告</router-link></li>
    </ul>
    <ul v-else>
      <li><router-link v-bind:to="{name:'company_index'}" exact>会社概要</router-link></li>
      <li><router-link v-bind:to="{name:'history_index'}" exact>沿革</router-link></li>
      <li><router-link v-bind:to="{name:'awards_index'}" exact>受賞歴</router-link></li>
      <li><router-link v-bind:to="{name:'sustainability_index'}" exact>サスティナビリティ</router-link></li>
      <li><router-link v-bind:to="{name:'comp_index'}" exact>決算公告</router-link></li>
    </ul>
  </div><!-- .page_sublink -->
</template>

<script>
export default {
  name: 'company_page_nav',
  created () {
    if(this.recruit_check()){
      if(this.$route.params.company === undefined){
        this.$route.params.company = 'company'
      }

    }
  },
  methods: {
    select_tab(name){
      if(this.$route.params.company == name){
        if(this.$route.params.company == 'sustainability'){
          $('body,html').stop().animate({scrollTop: 0}, 500, 'swing');
        }
        return 'router-link-exact-active router-link-active'
      }
    },
    recruit_check(){
      return ['recruit_2021','recruit_2022','recruit_2023','recruit_2024'].includes(this.$route.name)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/companyPageNav.vue